// Axios
import axios from 'axios'
import gql from 'graphql-tag'

const isNotEmpty = (value) => value !== undefined && value !== null && value !== ''

// GetAddress
export const GetAddress = (lat, lng) =>
  new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.VUE_APP_MAP_URL}reverse?lat=${lat}&lon=${lng}&format=json&accept-language=id`
      )
      .then((res) => {
        if (res.data.error || res.status != 200) {
          resolve({
            data: {
              display_name: '-',
              state: null,
              city: null,
            },
          })
        }
        const address = res.data.address
        let province = null
        let city = null

        if (isNotEmpty(address.state)) {
          province = address.state
        } else if (
          address.city === 'Special Region of Jakarta' ||
          address.city === 'Daerah Khusus Jakarta'
        ) {
          province = address.city
          city = address.city_district
        }

        if (!isNotEmpty(city))
          if (isNotEmpty(address.city)) city = address.city
          else if (isNotEmpty(address.county)) city = address.county
          else if (isNotEmpty(address.municipality)) city = address.municipality

        address.state = province
        address.city = city

        const nominatim = { data: { ...res.data, address } }

        resolve(nominatim)
      })
      .catch((err) => {
        reject(err)
      })
  })

// GetAddressData
export const GetAddressData = async function (lat, lang) {
  try {
    const res = await GetAddress(lat, lang)
    return { ...res.data, lat: lat, lon: lang }
  } catch (error) {
    return { display_name: '-', lat: lat, lon: lang }
  }
}

export const GET_ADDRESS = gql`
  query Geofences {
    geofences {
      isSuccessful
      message
      geofences {
        data {
          geofenceId
          companyId
          customerId
          fenceName
          type
          polyData
          circData
          address
          addressDetail
          province
          city
          postalCode
          category
          contactName
          phoneNo
          isGarage
          isServiceLoc
          isBillingAddr
          isDepot
          isAlert
          serviceStart
          serviceEnd
          breakStart
          breakEnd
          serviceLocType
          customerName
          hasRelation
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
